// extracted by mini-css-extract-plugin
export default {"btn":"sidebararrowbutton_btn__Bn4RA"};